import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { _getBuildings, _createBuilding, _createFloor, _uploadFloorImage, _getFloor, } from "../shared/httpservice/apis";
const createInitialState = () => ({
    loading: false,
    response: null,
    hasError: false,
    error: {},
});
const initialState = {
    buildings: createInitialState(),
    createBuilding: createInitialState(),
    createFloor: createInitialState(),
    uploadFloorImage: createInitialState(),
    getFloor: createInitialState(),
    getBaseFloorFeatures: {},
    getMapRotation: 0,
    getBaseFloorLevel: 0,
    getBaseFloor: {},
    getOtherFloors: {},
    activeBuilding: null
};
export const getBuildingAction = createAsyncThunk("floors/building", async (siteId, { rejectWithValue }) => {
    try {
        const response = await _getBuildings(siteId);
        return response;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const createBuildingAction = createAsyncThunk("floors/createBuilding", async (data, { rejectWithValue }) => {
    try {
        const response = await _createBuilding(data);
        return response;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const createFloorAction = createAsyncThunk("floors/createFloor", async (data, { rejectWithValue }) => {
    try {
        const response = await _createFloor(data);
        return response;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const uploadFloorImageAction = createAsyncThunk("floor/uploadFloorImage", async ({ siteId, floorId, data }, { rejectWithValue }) => {
    try {
        const response = await _uploadFloorImage({ siteId, floorId, data });
        return response;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
export const getFloorAction = createAsyncThunk("floor/getFloor", async ({ siteId, data, noLoading }, { rejectWithValue }) => {
    try {
        const response = await _getFloor({ siteId, data });
        return response;
    }
    catch (error) {
        return rejectWithValue(error);
    }
});
const floorSlice = createSlice({
    name: "floors",
    initialState,
    reducers: {
        resetFloorSlice: () => initialState,
        setBaseFloorFeaturesAction: (state, action) => {
            state.getBaseFloorFeatures = action.payload;
        },
        setMapRotationAction: (state, action) => {
            state.getMapRotation = action.payload;
        },
        setBaseFloorLevel: (state, action) => {
            state.getBaseFloorLevel = action.payload;
        },
        setBaseFloor: (state, action) => {
            state.getBaseFloor = action.payload;
        },
        setOtherFloor: (state, action) => {
            state.getOtherFloors = action.payload;
        },
        setActiveBuildingAction: (state, action) => {
            state.activeBuilding = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getBuildingAction.pending, (state) => {
            state.buildings.loading = true;
            state.buildings.response = null;
            state.buildings.hasError = false;
            state.buildings.error = {};
        })
            .addCase(getBuildingAction.fulfilled, (state, action) => {
            state.buildings.loading = false;
            state.buildings.response = action.payload;
            state.buildings.hasError = false;
            state.buildings.error = {};
        })
            .addCase(getBuildingAction.rejected, (state, action) => {
            state.buildings.loading = false;
            state.buildings.response = null;
            state.buildings.hasError = true;
            state.buildings.error = action.payload;
        })
            .addCase(createBuildingAction.pending, (state) => {
            state.createBuilding.loading = true;
            state.createBuilding.response = null;
            state.createBuilding.hasError = false;
            state.createBuilding.error = {};
        })
            .addCase(createBuildingAction.fulfilled, (state, action) => {
            state.createBuilding.loading = false;
            state.createBuilding.response = action.payload;
            state.createBuilding.hasError = false;
            state.createBuilding.error = {};
        })
            .addCase(createBuildingAction.rejected, (state, action) => {
            state.createBuilding.loading = false;
            state.createBuilding.response = null;
            state.createBuilding.hasError = true;
            state.createBuilding.error = action.payload;
        })
            .addCase(createFloorAction.pending, (state) => {
            state.createFloor.loading = true;
            state.createFloor.response = null;
            state.createFloor.hasError = false;
            state.createFloor.error = {};
        })
            .addCase(createFloorAction.fulfilled, (state, action) => {
            state.createFloor.loading = false;
            state.createFloor.response = action.payload;
            state.createFloor.hasError = false;
            state.createFloor.error = {};
        })
            .addCase(createFloorAction.rejected, (state, action) => {
            state.createFloor.loading = false;
            state.createFloor.response = null;
            state.createFloor.hasError = true;
            state.createFloor.error = action.payload;
        })
            .addCase(uploadFloorImageAction.pending, (state) => {
            state.uploadFloorImage.loading = true;
            state.uploadFloorImage.response = null;
            state.uploadFloorImage.hasError = false;
            state.uploadFloorImage.error = {};
        })
            .addCase(uploadFloorImageAction.fulfilled, (state, action) => {
            state.uploadFloorImage.loading = false;
            state.uploadFloorImage.response = action.payload;
            state.uploadFloorImage.hasError = false;
            state.uploadFloorImage.error = {};
        })
            .addCase(uploadFloorImageAction.rejected, (state, action) => {
            state.uploadFloorImage.loading = false;
            state.uploadFloorImage.response = null;
            state.uploadFloorImage.hasError = true;
            state.uploadFloorImage.error = action.payload;
        })
            .addCase(getFloorAction.pending, (state, action) => {
            const { meta: { arg: { noLoading }, }, } = action;
            if (!noLoading) {
                state.getFloor.loading = true;
                state.getFloor.response = null;
                state.getFloor.hasError = false;
                state.getFloor.error = {};
            }
        })
            .addCase(getFloorAction.fulfilled, (state, action) => {
            state.getFloor.loading = false;
            state.getFloor.response = action.payload;
            state.getFloor.hasError = false;
            state.getFloor.error = {};
        })
            .addCase(getFloorAction.rejected, (state, action) => {
            state.getFloor.loading = false;
            state.getFloor.response = null;
            state.getFloor.hasError = true;
            state.getFloor.error = action.payload;
        });
    },
});
export const { resetFloorSlice, setBaseFloorFeaturesAction, setBaseFloorLevel, setMapRotationAction, setBaseFloor, setOtherFloor, setActiveBuildingAction } = floorSlice.actions;
export default floorSlice.reducer;
